const UPDATE_NICKNAME = `
  mutation UpdateNickname($nickname: String!) {
    me {
      updateUserProfile(input: { nickname: $nickname }) {
        nickname
      }
    }
  }
`;

export default UPDATE_NICKNAME;
